<template>
  <div class="template-mgmt">
    <div class="template-tabs">
      <div
        v-for="tab in tabs"
        :key="tab.name"
        class="template-tab-item"
        :class="{ 'text-primary font-medium': tab.name === currentTab }"
        @click="currentTab = tab.name"
      >
        <p>{{ tab.label }}</p>
      </div>
    </div>
    <div>
      <component :is="currentComponent"></component>
    </div>
  </div>
</template>

<script>
import TagManagement from "./tagManagement/index.vue";
import PublisherManagement from "./publisherManagement/index.vue";

export default {
  name: "GeneralSettings",
  components: {
    TagManagement,
    PublisherManagement
  },
  data() {
    return {
      currentTab: "TagManagement",
      tabs: [
        {
          name: "TagManagement",
          label: "标签管理",
          component: TagManagement
        },
        {
          name: "PublisherManagement",
          label: "发布人管理",
          component: PublisherManagement
        }
      ]
    };
  },
  computed: {
    currentComponent() {
      const tab = this.tabs.find(tab => tab.name === this.currentTab);
      return tab ? tab.component : null;
    }
  }
};
</script>

<style scoped>
  .template-mgmt {
  background: #ffffff;
}

.template-tabs {
  display: flex;
  padding: 16px;
  border: 0;
  border-bottom: 1px solid #e5e7eb;
  gap: 20px;
}

.template-tab-item {
  cursor: pointer;
  font-size: 14px;
  color: #606266;
}

.template-tab-item:hover {
  color: #409eff;
}
.text-primary {
  color: #409eff;
}
.border-gray-200 {
  border-color: #e5e7eb;
}
</style>

